// extracted by mini-css-extract-plugin
export default {"deleteDialog":"DeleteSandboxActionHandler_deleteDialog__-mWOo","content":"DeleteSandboxActionHandler_content__OwulM"};